export default __webpack_public_path__ + "static/media/Mark-4-HUD-Targeting (Target Lock).4ca45c3f.jpg";